// Dependencies
import React, {Component} from 'react';
import {Col, Grid, Row} from 'react-material-responsive-grid';
import {AppEnv} from '../env';
import Loading from '../Global-W/Classes/Loading';
import AspirantesTutor from '../Preinscripciones-W/Tutor/Inscripciones/AspirantesTutor';
import Preinscrip from '../Preinscripciones-W/New/Preinscrip';
import {confirmAlert} from 'react-confirm-alert';
import 'react-responsive-modal/styles.css';
import {Modal} from 'react-responsive-modal';
import SelectEscuela from '../Preinscripciones-W/SelectEscuela';
import {connect} from 'react-redux';
import {fetchCountries, setCountry} from '../../redux/actions/GestionActions/GestionActions';
import {setInitValues} from "../../redux/actions";
import {alertFail, alertWarning, customAlert, getLogo, pulseLoader, suspenseFallback} from "../Global-W/NewFunctions";


const moment = require('moment');
require('moment/locale/es');
moment.locale('es');

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            dataEscuela: [],
            configData: [],
            role: '',
            logo: '',
            fondo: 'https://s3-us-west-2.amazonaws.com/galeriasce/IMG-Escuelas/' + AppEnv.NombreCorto + '/1.jpg',
            esc: [],
            email: '',
            emailPreinscrip: '',
            password: '',
            passwordPreinscrip: '',
            selected: '',
            bd: '',
            loading: false,
            loadingLogin: true,
            escuelas: [],
            admision: false,
            dataBase: '',
            fase: '',
            id_escuela: '',
            tipoBusqueda: [
                {tipo: 'Código postal'},
                {tipo: 'Ciudad'},
                {tipo: 'CCT'}
            ],
            nivelesEscolares: [
                {nivel: 'PREESCOLAR'},
                {nivel: 'PRIMARIA'},
                {nivel: 'SECUNDARIA'},
                {nivel: 'PREPARATORIA'}
            ],
            elNivel: '',
            laEscuela: [],
            elTipo: '',
            indxEsc: -1,
            lasEscuelas: [],
            preinscrip: false,
            dataSchool: [],
            hasIdTutor: false,
            selectedSchool: -1,
            selectLevels: false,
            loginInputs: false,
            modalNip: false,
            emailNip: '',
            searchSchool: false,
            loadingEscuelas: false,
            globals: [],
            otherGlobals: [],
            laPagina: '',
            nameCiclo: '',
            mobile: false,
            capsLock: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        // this.handlePasswordPreinscrip() = this.handlePasswordPreinscrip.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        // this.handleEmailPreinscrip() = this.handleEmailPreinscrip.bind(this);
    }

    // <=<●>=><=<●>=><=<●>=> ComponentDidMount <=<●>=><=<●>=><=<●>=>
    async fetchCountries() {
        await this.props.fetchCountries();
    };

    isMobile() {
        this.setState({
            mobile: (navigator.userAgent.match(/Android/i)) ||
                (navigator.userAgent.match(/webOS/i)) ||
                (navigator.userAgent.match(/iPhone/i)) ||
                (navigator.userAgent.match(/iPod/i)) ||
                (navigator.userAgent.match(/iPad/i)) ||
                (navigator.userAgent.match(/BlackBerry/i))
        })
    }

    async componentDidMount() {
        try {
            await this.fetchCountries();
            this.props.country.globals.forEach(it => {
                this.props.setCountry(it);
                this.state.globals[it.option] = it.value;
            });
            await this.isMobile();
            await this.fondoAleatorio();
            await this.getPropertiesAdmision();
            let tutor = await sessionStorage.getItem('idTutor');
            await this.setState({hasIdTutor: tutor !== null});
        } catch (e) {
            console.error('Error ->', e)
        } finally {
            this.setState({loadingLogin: false})
        }
    }

    async getPropertiesAdmision() {
        this.setState({loadingLogin: true})
        let tutor = await sessionStorage.getItem('idTutor');
        let objectSchool = window.location.pathname.split('/');
        if (objectSchool[2] !== undefined) {
            let dataSchool = [];
            let urlFetch = AppEnv.apiGes + 'data/school/' + objectSchool[2];
            if (objectSchool[3] !== undefined) {
                urlFetch = AppEnv.apiGes + 'escuela/datos/' + objectSchool[2];
            }
            await fetch(urlFetch, {
                method: 'GET', headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json())
                .then(responseJson => {
                    if (responseJson.error === undefined) {
                        dataSchool = responseJson[0];
                    }
                })
                .catch(error => {
                    console.error('error -> ', error)
                })
            if (tutor === null) {
                await this.setState({
                    dataSchool: dataSchool,
                    otherGlobals: dataSchool.globals,
                    preinscrip: true,
                    admision: true,
                    searchSchool: false,
                    linkActive: true,
                    loadingLogin: false
                });
            } else {
                await this.setState({loadingLogin: false})
            }
        }
    }

    async getEscuelasById() {
        if (AppEnv.tipoApp === '1') {
            await fetch(AppEnv.apiGes + 'cambio/escuela/get/by/id/' + AppEnv.SchoolId, {
                method: 'GET', headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json())
                .then(responseJson => {
                    if (responseJson.length === 1) {
                        this.setState({
                            dataBase: responseJson[0].cct,
                            selectedSchool: 0,
                            fase: responseJson[0].plan,
                            id_escuela: responseJson[0].id
                        });
                        let nombre = AppEnv.app;
                        let object = {
                            nombre_corto: nombre,
                            url: responseJson[0].url,
                            id: responseJson[0].id,
                            bd: this.state.dataBase
                        };
                        this.setState({
                            dataSchool: responseJson[0],
                            otherGlobals: responseJson[0].globals,
                            preinscrip: true
                        });
                    } else {
                        this.setState({selectLevels: true});
                        let a = [];
                        responseJson.forEach((itm, i) => {
                            if (itm.nivel === 'PREESCOLAR') {
                                a.push(itm);
                            }
                        });
                        responseJson.forEach((itm, i) => {
                            if (itm.nivel === 'PRIMARIA') {
                                a.push(itm);
                            }
                        });
                        responseJson.forEach((itm, i) => {
                            if (itm.nivel === 'SECUNDARIA') {
                                a.push(itm);
                            }
                        });
                        responseJson.forEach((itm, i) => {
                            if (itm.nivel === 'PREPARATORIA') {
                                a.push(itm);
                            }
                        });
                        this.setState({escuelas: a});
                    }
                });
        } else {
            await this.setState({selectLevels: true});
        }
    }

    async onSelectedSchool(itm, ix) {
        await this.setState({dataBase: itm.cct, selectedSchool: ix, fase: itm.plan, id_escuela: itm.id});
        let nombre = AppEnv.app;
        let object = {nombre_corto: nombre, url: itm.url, id: itm.id, bd: this.state.dataBase};
        await this.setState({dataSchool: itm, otherGlobals: itm.globals});
    }

    btnSchool(itm, ix) {
        let selected = this.state.selectedSchool === ix;
        return (
            <Col className="uk-width-1-3 centerAll" style={{margin: 0, padding: 3}}>
                <button className="uk-width-1-1" style={{
                    margin: 0,
                    padding: 5,
                    borderRadius: 6,
                    border: '1.5px solid',
                    borderColor: selected ? AppEnv.mainColor : AppEnv.secondColor,
                    backgroundColor: selected ? AppEnv.mainColor : '#fff'
                }} onClick={() => this.onSelectedSchool(itm, ix)}>
                    <label style={{color: selected ? '#fff' : AppEnv.secondColor, textAlign: 'center'}}>
                        {itm.nivel}
                    </label>
                </button>
            </Col>
        );
    }

    rndLevels() {
        let btnLvl = [];
        if (this.state.escuelas.length !== 0) {
            for (let i = 0; i < this.state.escuelas.length; i = i + 3) {
                btnLvl.push(
                    <Row key={i + 'level'} className='uk-width-1-1 centerAll'
                         style={{marginTop: 15, marginBottom: 5}}>
                        {this.btnSchool(this.state.escuelas[i], i)}
                        {this.state.escuelas.length > i + 1 ? this.btnSchool(this.state.escuelas[i + 1], i + 1) : null}
                        {this.state.escuelas.length > i + 2 ? this.btnSchool(this.state.escuelas[i + 2], i + 2) : null}
                    </Row>
                );
            }
        }
        return btnLvl;
    }

    // <=<●>=><=<●>=><=<●>=> Escuelas <=<●>=><=<●>=><=<●>=>

    getEscuelasInst(mail, pass) {
        if (mail === '' || pass === '') {
            let text = 'Campos vacíos';
            alertWarning(text);
        } else {
            this.setState({loadingEscuelas: true});
            return fetch(AppEnv.apiGes + 'cambio/escuela/get/by/id/mail/' + AppEnv.SchoolId + '/' + mail, {
                method: 'GET', headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json())
                .then(responseJson => {
                    this.setState({esc: responseJson});
                    if (responseJson.length === 1) {
                        this.selectEscuela(0);
                        this._accesApp(this.state.email, this.state.password, this);
                    }
                    if (responseJson.length === 0) {
                        alertWarning('Usuario o contraseña Incorrectos', 'Ingresa los datos correctos');
                    }
                    this.setState({loadingEscuelas: false});
                });
        }
    }

    _accesApp = (mail, pass) => {
        this.setState({loading: true});
        if (mail === '' || pass === '') {
            let text = 'Campos vacíos';
            alertWarning(text);
        } else {
            return fetch(AppEnv.api + this.state.bd + '/access/user/login', {
                method: 'POST', headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({email: mail})
            }).then(response => response.json())
                .then(responseJson => {
                    if (responseJson.activo === '1'
                        || responseJson.activo === 1 || responseJson.activo === '3' || responseJson.activo === 3 || responseJson[0] === 'no hay nada') {
                        this.checkSession(mail, pass);
                    } else if (responseJson.activo === 2 || responseJson.activo === '2') {
                        alertFail('Acceso denegado usted ya no tiene acceso a la plataforma.');
                    }
                }).catch((e) => {
                    alertFail()
                    this.setState({loading: false});
                });
        }
    };

    async checkSession(mail, pass) {
        let tutor = await sessionStorage.getItem('idTutor');
        if (tutor !== null) {
            alertFail('Proceso de preinscripción incompleto', 'Debe concluir el proceso de preinscripción para poder iniciar sesión en el menú principal');
        } else {
            this._fetchLoginData(mail, pass);
        }
    }

    renderEscuelas() {
        let buttons = [];
        if (this.state.esc.length > 4) {
            this.state.esc.forEach((it, i) => {
                buttons.push(
                    <option
                        key={'escuelas' + i}
                        value={i}
                        style={{
                            padding: 5,
                            borderRadius: 6,
                            margin: 3
                        }}>
                        {AppEnv.tipoApp === '1' ?
                            it.conjunto_uno
                            : it.nombre_escuela + ' ' + it.conjunto_uno + ' (' + it.turno_escuela[0] + ')'}
                    </option>
                );
            });
        } else {
            this.state.esc.forEach((it, i) => {
                buttons.push(
                    <div key={'escuelas' + i} onClick={() => {
                        this.selectEscuela(i);
                    }} style={{
                        backgroundColor: this.state.selected === i ? AppEnv.mainColor : AppEnv.secondColor,
                        padding: 5,
                        borderRadius: 6,
                        margin: 3
                    }}>
                        {AppEnv.tipoApp === '1' ?
                            <span style={{
                                textAlign: 'center',
                                color: AppEnv.fourthColor
                            }}>{it.conjunto_uno}</span>
                            : <span style={{
                                textAlign: 'center',
                                color: AppEnv.fourthColor
                            }}>{it.nombre_escuela + ' ' + it.conjunto_uno + ' (' + it.turno_escuela[0] + ')'}</span>}
                    </div>
                );
            });
        }
        return buttons;
    }

    async selectEscuela(i) {
        let bd = this.state.esc[i].cct;
        this.state.esc[i].globals.forEach((it) => {
            sessionStorage.setItem(it.option, it.value);
        });
        sessionStorage.setItem('id_pais', this.state.esc[i].id_pais);
        let nameCiclo = this.state.esc[i].nivel === 'PREPARATORIA' ? 'Semestre' : 'Ciclo';
        await this.setState({
            bd: bd,
            selected: i,
            fase: this.state.esc[i].plan,
            id_school: this.state.esc[i].id,
            id_pais: this.state.esc[i].id_pais,
            nameCiclo: nameCiclo
        });
        await this.saveNameCiclo();
    }

    async saveNameCiclo() {
        try {
            sessionStorage.setItem('nameCiclo', this.state.nameCiclo);
        } catch (error) {
            console.error('Ocurrió un error ' + error);
        }
    }

    // <=<●>=><=<●>=><=<●>=> Original <=<●>=><=<●>=><=<●>=>

    _fetchLoginData = (mail, pass) => {
        fetch(AppEnv.api + this.state.bd + '/auth/login', {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json'
                }, body: JSON.stringify({
                    email: mail, password: pass
                })
            }
        ).then(res => res.json())
            .then(responseJson => {
                if (responseJson.token === undefined) {
                    this.setState({loading: false});
                    switch (responseJson.error) {
                        case 422:
                            alertWarning('Formato inválido', 'Es necesario poner un email válido.');
                            break;
                        case undefined:
                            alertWarning('Usuario o contraseña Incorrectos', 'Ingresa los datos correctos');
                            break;
                        case 'Unauthorized':
                            alertWarning('Usuario o contraseña Incorrectos', 'Ingresa los datos correctos');
                            break;
                        case 403:
                            alertWarning('Usuario o contraseña incorrectos', 'Si el error persiste solicite ayuda.');
                            break;
                        case 500:
                            alertFail('Error interno', 'Por el momento no se puede procesar su solicitud, intente mas tarde.');
                            break;
                        default:
                            alertFail('Error:' + responseJson.error, 'Solicite ayuda por favor');
                    }
                } else {
                    this.saveItem('token', responseJson.token);
                    if (responseJson.data.passwordUpdated === '0') {
                        this.saveItem('email', mail);
                        this.saveItem('bd', this.state.bd);
                        this.saveItem('nameCiclo', this.state.nameCiclo);
                        this.props.history('/change/password');
                    } else {
                        let data = {
                            bd: this.state.bd,
                            country: this.state.id_pais,
                            email: responseJson.email,
                            grado: responseJson.grado,
                            grupo: responseJson.grupo,
                            id: responseJson.id,
                            name: responseJson.name,
                            puesto: responseJson.puesto,
                            role: responseJson.role,
                            roles: JSON.stringify(responseJson.roles),
                            schoolId: this.state.id_school,
                            terminos_condiciones: responseJson.data.terminos_condiciones,
                            token: responseJson.token,
                            userPicture: responseJson.photo,
                            userRoleAlias: responseJson.alias === null ? '' : responseJson.alias,
                            activo: responseJson.activo,
                            estatus: responseJson.estatus,
                        }

                        this.props.setInitValues(data)
                        this.saveItem('role', responseJson.role);
                        this.saveItem('roles', JSON.stringify(responseJson.roles));
                        this.saveItem('id', responseJson.id);
                        this.saveItem('puesto', responseJson.puesto);
                        this.saveItem('userRoleAlias', responseJson.alias === null ? '' : responseJson.alias);
                        this.saveItem('schoolId', this.state.id_school);
                        this.saveItem('grado', responseJson.grado);
                        this.saveItem('grupo', responseJson.grupo);
                        this.saveItem('token', responseJson.token);
                        this.saveItem('name', responseJson.name);
                        this.saveItem('email', responseJson.email);
                        this.saveItem('activo', responseJson.activo);
                        this.saveItem('estatus', responseJson.estatus !== null ? responseJson.estatus : '');
                        this.saveItem('bd', this.state.bd);
                        this.saveItem('terminos_condiciones', responseJson.data.terminos_condiciones);
                        this.saveItem('userPicture', responseJson.photo);
                        this.props.history('/dashboard');
                        this.setState({show: false});
                    }
                }
            });
    };

    handleEmail(event) {
        this.setState({email: event.target.value});
    }

    handlePassword(event) {
        this.setState({password: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    fondoAleatorio() {
        let r = Math.floor(Math.random() * 4) + 1;
        let pic = '';
        switch (r) {
            case 0:
                pic = 'https://s3-us-west-2.amazonaws.com/galeriasce/IMG-Escuelas/' + AppEnv.NombreCorto + '/1.jpg';
                break;
            case 1:
                pic = 'https://s3-us-west-2.amazonaws.com/galeriasce/IMG-Escuelas/' + AppEnv.NombreCorto + '/2.jpg';
                break;
            case 2:
                pic = 'https://s3-us-west-2.amazonaws.com/galeriasce/IMG-Escuelas/' + AppEnv.NombreCorto + '/3.jpg';
                break;
            case 3:
                pic = 'https://s3-us-west-2.amazonaws.com/galeriasce/IMG-Escuelas/' + AppEnv.NombreCorto + '/4.jpg';
                break;
            case 4:
                pic = 'https://s3-us-west-2.amazonaws.com/galeriasce/IMG-Escuelas/' + AppEnv.NombreCorto + '/5.jpg';
        }
        this.setState({fondo: pic});
    }


    handleChange(e) {
        this.setState({capsLock: e.getModifierState('CapsLock')})
        if (e.key == 'Enter') {
            if (this.state.email !== '' && this.state.password !== '') {
                if (this.state.selected === '') {
                    this.getEscuelasInst(this.state.email, this.state.password);
                } else {
                    this._accesApp(this.state.email, this.state.password);
                }
            }
        }
    }

    rndLogin() {
        return (<Row
            style={{
                backgroundColor: AppEnv.fourthColor,
                height: '100vh',
                margin: 0,
                padding: 0,
                justifyContent: 'center'
            }} className='centerAll uk-width-5-6 uk-width-2-3@s uk-width-5-6@m uk-width-2-3@l  centerAll'>
            <Row className="uk-width-1-1 centerAll">
                <div className="uk-width-1-1">
                    <Row style={{
                        padding: 0,
                        margin: 0,
                        justifyContent: 'flex-start',
                        alignItems: 'center'
                    }} className='uk-width-1-1'>
                        <a className='uk-link-heading' onClick={() => window.location.assign(AppEnv.SitioWeb)}>
                            <i className="fas fa-arrow-circle-left fa-1x" style={{color: 'black'}}/>
                            <label className='normal_text'
                                   style={{marginLeft: 10, textAlign: 'left', lineHeight: 1.25}}>
                                Página principal del colegio
                            </label>
                        </a>
                    </Row>

                </div>
                <Row style={{marginBottom: 5, padding: 5, marginTop: 25}} className='centerAll'>
                    <img className='lazyload imagenl' data-src={getLogo()}
                         alt=''/>
                </Row>
                <p style={{marginTop: 25, color: AppEnv.secondColor}}
                   className='subnegritas uk-width-1-1'>¡Bienvenido!</p>
                <form className='uk-form-stacked uk-width-1-1'
                      onSubmit={this.handleSubmit}>
                    <div>
                        <label className='labelform section_title_two'>
                            Nombre de usuario
                        </label>
                        {this.state.capsLock ?
                            <div style={{float: 'right'}}>
                                <i style={{margin: 0, fontSize: 12}}
                                   className={'fas fa-lock'}
                                   data-uk-tooltip='Mayúsculas activadas'/>
                            </div> : null}
                        <div>
                            <input
                                style={{borderRadius: 6, textAlign: 'left'}}
                                className='uk-input uk-width-1-1 work1'
                                onChange={this.handleEmail}
                                id='login-form-ce-username'
                                type='email'
                                onKeyPress={(e) => this.handleChange(e)}
                                placeholder='correo@ejemplo.com'/>
                        </div>
                    </div>
                    <Row style={{marginTop: 10, flexWrap: 'wrap'}} className='uk-width-1-1'>
                        {this.state.esc.length !== 1
                            ? this.state.esc.length > 4 ?
                                <select className="uk-select normal_text uk-width-1-1"
                                        style={{borderRadius: 6, textAlignLast: 'center'}}
                                        onChange={(event) => this.selectEscuela(event.target.value)}>
                                    <option key={0} value={0}>Seleccione un colegio</option>
                                    {this.renderEscuelas()}
                                </select>
                                : this.renderEscuelas()
                            : null}
                    </Row>
                    <div style={{marginTop: 10}} className='centerAll'>
                        <label className='labelform section_title_two'>
                            Contraseña
                        </label>
                        <div>
                            <input
                                style={{borderRadius: 6, textAlign: 'left'}}
                                className='uk-input uk-width-1-1 work1'
                                onChange={this.handlePassword}
                                id='login-form-ce-password'
                                type='password'
                                onKeyPress={(e) => this.handleChange(e)}
                                placeholder='***********'/>
                        </div>
                        <Row className='centerAll'>
                            {this.state.loadingEscuelas
                                ? <div
                                    className='uk-width-2-3 botontxt'
                                    style={{
                                        padding: 10,
                                        lineHeight: 1,
                                        backgroundColor: AppEnv.mainColor,
                                        borderRadius: 7,
                                        marginTop: 25
                                    }}>
                                    {pulseLoader(AppEnv.fourthColor)}
                                </div>
                                : this.state.selected === ''
                                    ? <Row
                                        className='uk-width-2-3 centerAll botontxt'
                                        style={{
                                            padding: 10,
                                            lineHeight: 1,
                                            backgroundColor: AppEnv.mainColor,
                                            borderRadius: 7,
                                            marginTop: 25
                                        }}
                                        onClick={() => this.getEscuelasInst(this.state.email, this.state.password)}>
                                        <label className="uk-text-truncate">CONTINUAR</label>
                                    </Row>
                                    : <Row
                                        className='uk-width-2-3 centerAll botontxt'
                                        style={{
                                            padding: 10,
                                            lineHeight: 1,
                                            backgroundColor: AppEnv.mainColor,
                                            borderRadius: 7,
                                            marginTop: 25
                                        }}
                                        onClick={() => this._accesApp(this.state.email, this.state.password, this)}>
                                        <label className="uk-text-truncate">INICIAR SESIÓN</label>
                                    </Row>
                            }
                        </Row>
                        <Row style={{marginTop: 20}} className="uk-width-1-1 centerAll ">
                            <div className='uk-width-1-2 centerAll section_title_two' style={{textAlign: 'center'}}>
                                <a className='uk-link-heading' onClick={() => this.props.history('/password')}>
                                    <small>Olvidé mi contraseña</small>
                                </a>
                            </div>
                        </Row>
                        <Row style={{marginTop: 20}}
                             className="uk-width-1-1 centerAll section_title_two">
                            <Col className="uk-width-1-2" style={{margin: 0, padding: 3}}>
                                <Row style={{
                                    margin: 0,
                                    borderRadius: 6,
                                    lineHeight: 1,
                                    border: '1px solid',
                                    borderColor: AppEnv.secondColor,
                                    backgroundColor: AppEnv.secondColor,
                                    textAlign: 'center',
                                    padding: 8,
                                    color: AppEnv.fourthColor
                                }} onClick={() => this.setState({admision: true, loadingLogin: false})}
                                     className='uk-width-1-1 centerAll uk-link-heading'>
                                    <label className='uk-text-truncate'>ADMISIONES</label>
                                </Row>
                            </Col>
                            <Col className="uk-width-1-2" style={{margin: 0, padding: 3}}>
                                <Row style={{
                                    borderRadius: 6,
                                    lineHeight: 1,
                                    border: '1px solid',
                                    borderColor: AppEnv.secondColor,
                                    backgroundColor: AppEnv.fourthColor,
                                    textAlign: 'center',
                                    padding: 8,
                                    color: AppEnv.secondColor
                                }}
                                     onClick={() => this.props.history('/register')}
                                     className='uk-width-1-1 centerAll uk-link-heading'>
                                    <label className='uk-text-truncate' style={{
                                        textDecoration: "none",
                                    }}>
                                        REGISTRARME
                                    </label>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{marginTop: 20}} className="uk-width-1-1 centerAll ">
                            <a className='uk-link-heading' href="https://www.kolegia.com">
                                <div className='centerAll normal_text' style={{textAlign: 'center', lineHeight: 1}}>
                                    <small>Plataforma desarrollada con la tecnología
                                        de<br/>Kolegia School Manager, 2017-{moment().format('Y')}. Todos los derechos
                                        reservados.
                                    </small>
                                </div>
                            </a>
                        </Row>
                    </div>
                </form>
            </Row>
        </Row>);
    }

    rndLoginMobile() {
        return (<Row
            style={{
                backgroundColor: AppEnv.fourthColor,
                margin: 0,
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                padding: '0 30px',
            }} className='uk-width-1-1'>
            <Row className="uk-width-1-1 centerAll">
                <div className="uk-width-1-1">
                    <Row style={{
                        padding: 0,
                        margin: 0,
                        justifyContent: 'flex-start',
                        alignItems: 'center'
                    }} className='uk-width-1-1'>
                        <a className='uk-link-heading' onClick={() => window.location.assign(AppEnv.SitioWeb)}>
                            <i className="fas fa-arrow-circle-left fa-1x" style={{color: 'black'}}/>
                            <label className='normal_text'
                                   style={{marginLeft: 10, textAlign: 'left', lineHeight: 1.25}}>
                                Página principal
                            </label>
                        </a>
                    </Row>

                </div>
                <Row style={{marginBottom: 5, padding: 5, marginTop: 30}} className='centerAll'>
                    <img className='lazyload imagenLMovil' data-src={getLogo()}
                         alt=''/>
                </Row>
                <p style={{marginTop: 25, color: AppEnv.secondColor}}
                   className='subnegritas uk-width-1-1'>¡Bienvenido!</p>
                <Row className="uk-width-1-1 centerAll sub_title"
                >
                    Está intentando acceder a {AppEnv.name} desde el navegador web de su teléfono móvil. Para
                    disfrutar de una experiencia óptima de la plataforma en su móvil, por favor descargue la App usando
                    la tienda
                    de aplicaciones correspondiente:
                </Row>

                <Row className="uk-width-1-1 centerAll"
                     style={{marginTop: 10, padding: 0}}>
                    <Row style={{
                        margin: 0,
                        padding: 5
                    }}
                         onClick={() => window.open(AppEnv.iOS)}
                         className="uk-width-1-2@s uk-width-1-2@m">
                        <img alt='' className="lazyload"
                             data-src="https://otrasimagenes.s3.amazonaws.com/generales/AppStore.png"/>
                    </Row>

                    <Row style={{
                        margin: 0,
                        padding: 5,
                    }}
                         onClick={() => window.open(AppEnv.Android)}
                         className="uk-width-1-2@s uk-width-1-2@m">
                        <img alt='' className="lazyload"
                             data-src="https://otrasimagenes.s3.amazonaws.com/generales/PlayStore.png"/>
                    </Row>

                    <Row style={{
                        margin: 0,
                        padding: 5,
                    }}
                         onClick={() => window.open(AppEnv.AppGallery)}
                         className="uk-width-1-2@s uk-width-1-2@m">
                        <img alt='' className="lazyload"
                             data-src="https://otrasimagenes.s3.amazonaws.com/generales/AppGallery.png"/>
                    </Row>
                </Row>

                <Row className="uk-width-1-1 centerAll"
                     style={{margin: 0, padding: 5}}
                     onClick={() => this.setState({mobile: false})}>
                    <Row className=" centerAll normal_text"
                         style={{margin: 0, padding: 5, border: '1px solid', borderRadius: 6}}>
                        Ir a login
                    </Row>
                </Row>
            </Row>
        </Row>);
    }

    async seguirProceso() {
        if (this.state.selectedSchool === -1 && this.state.escuelas.length !== 0) {
            alertWarning('Seleccione un nivel para poder continuar');
        } else {
            await this.setState({preinscrip: true});
        }
    }

    //-+-+-+-+-+-+-+-+-+ Seleccion niveles esc perzonalizada
    rndTwoBtns() {
        return (
            <div className="uk-width-1-1 centerAll">
                <div style={{marginTop: 25, color: AppEnv.secondColor, textAlign: 'center'}}
                     className='uk-width-1-1 centerAll subnegritas'>¡Quiero ser parte!
                </div>
                <div className="normal_text" style={{
                    margin: 0,
                    padding: 0,
                    lineHeight: 1,
                    marginTop: 10,
                    textAlign: 'left',
                    fontSize: '.8rem'
                }}>
                    Ahora podrás realizar de manera y de una manera muy sencilla, el proceso de <label
                    className="section_title_two"
                    style={{fontSize: '.8rem'}}>preinscripción</label> a nuestro colegio, en tan
                    solo un click
                </div>
                <Row className="uk-width-1-1 centerAll" style={{
                    margin: 0,
                    padding: 10,
                    backgroundColor: AppEnv.secondColor,
                    borderRadius: 6,
                    marginTop: 25
                }} onClick={() => this.getEscuelasById()}>
                    <label className="txtnegritas" style={{color: AppEnv.fourthColor}}>
                        Iniciar proceso de admisión
                    </label>
                </Row>
                <Row className="uk-width-1-1 centerAll" style={{
                    margin: 0,
                    padding: 10,
                    border: '1px solid',
                    marginTop: 10,
                    borderRadius: 6,
                    borderColor: AppEnv.secondColor,
                    backgroundColor: AppEnv.fourthColor
                }} onClick={() => this.setState({loginInputs: true})}>
                    <label className="txtnegritas" style={{color: AppEnv.secondColor}}>
                        Continuar proceso de admisión
                    </label>
                </Row>
            </div>
        );
    }

    //-+-+-+-+-+-+-+-+-+ Seleccion niveles para kolegia y CE
    async selectNivel(it, i) {
        await this.setState({elNivel: it, laEscuela: [], indxEsc: -1, lasEscuelas: []});
    }

    async selecTipoSearch(itm, i) {
        await this.setState({elTipo: itm.tipo, laEscuela: [], indxEsc: -1});
    }

    async startSearch() {
        if (this.state.elNivel === '') {
            alertWarning('Seleccione primero un nivel escolar para poder continuar');
        } else {
            await this.setState({searchSchool: true});
        }
    }

    handleLink = (e) => {
        this.setState({laPagina: e.target.value})
    }

    async validationLink(laPagina) {
        let objectSchool = laPagina.split('/');
        if (objectSchool[2] !== undefined && objectSchool[3] !== undefined) {
            if (objectSchool[3] === 'Admisiones' || objectSchool[3] === 'Login') {
                window.location.assign(laPagina);
            } else {
                alertWarning('Verifique el enlace que ha capturado. Asegúrese de haberlo escrito tal como el colegio se lo indicó');
            }
        } else {
            alertWarning('Verifique el enlace que ha capturado. Asegúrese de haberlo escrito tal como el colegio se lo indicó')
        }
    }

    rndSelectEsc() {
        const contriesButtons = this.props.countries.map((it, i) =>
            (<Row
                key={i + 'country'}
                className="uk-width-1-3 centerAll"
                style={{margin: 0, padding: 2}}>
                <Row
                    key={i}
                    className='uk-width-1-1 centerAll section_title_two'
                    style={{
                        margin: 2,
                        padding: 8,
                        borderRadius: 6,
                        backgroundColor: it.id === this.props.country.id ? AppEnv.secondColor : AppEnv.grayColorOne,
                        color: it.id === this.props.country.id ? AppEnv.fourthColor : AppEnv.fifthColor,
                        alignItems: 'center',
                        fontSize: '.7rem'
                    }}
                    onClick={() => {
                        this.props.setCountry(it);
                        it.globals.forEach(it => (
                            this.state.globals[it.option] = it.value
                        ));
                        this.setState({aux: 0});
                    }}>
                    <label className='uk-text-truncate'>{it.nombre}</label>
                </Row>
            </Row>)
        );
        return (<div className="uk-width-1-1 centerAll">
            <div style={{marginTop: 25, color: AppEnv.secondColor, textAlign: 'center'}}
                 className='uk-width-1-1 centerAll subnegritas'>¿Tiene un enlace?
            </div>
            <div className="normal_text" style={{
                margin: 0,
                padding: 0,
                marginTop: 10,
                lineHeight: 1,
                textAlign: 'left',
                fontSize: '.8rem'
            }}>
                Capture el link que el colegio le ha proporcionado para comenzar un proceso de <label
                className="section_title_two"
                style={{
                    margin: 0,
                    padding: 0,
                    fontSize: '.8rem'
                }}>admisión</label>
            </div>
            <div>
                <label className='labelform section_title_two'>
                    Link del colegio
                </label>
                <div>
                    <input
                        style={{borderRadius: 6, textAlign: 'left'}}
                        className='uk-input uk-width-1-1 work1'
                        onChange={this.handleLink}
                        id='login-form-ce-username'
                        type='text'
                        // onKeyPress={(e) => this.handleChange(e)}
                        placeholder='https://wwww.ejemplo.com'/>
                </div>
            </div>
            {/*<Row style={{marginTop: 10}} className='uk-width-1-1 main_title'>*/}
            {/*    Seleccione un país*/}
            {/*</Row>*/}
            {/*<Row style={{maginTop: 5}} className="uk-width-1-1 centerAll">*/}
            {/*    {contriesButtons}*/}
            {/*</Row>*/}
            {/*<Row style={{marginTop: 10}} className='uk-width-1-1 main_title'>*/}
            {/*    Seleccione el nivel educativo*/}
            {/*</Row>*/}
            {/*<Row style={{maginTop: 5}} className="uk-width-1-1 centerAll">*/}
            {/*    {this.rndTipeLvl()}*/}
            {/*</Row>*/}
            <Row className="uk-width-1-1 centerAll" style={{
                margin: 0,
                padding: 10,
                backgroundColor: AppEnv.secondColor,
                borderRadius: 6,
                marginTop: 15
            }}
                // onClick={() => this.startSearch()}
                 onClick={() => {
                     if (this.state.laPagina !== '') {
                         this.validationLink(this.state.laPagina);
                     } else {
                         alertWarning('Capture el link proporcionado por el colegio para poder continuar')
                     }
                 }}
            >
                <label className="txtnegritas uk-text-truncate" style={{color: AppEnv.fourthColor}}>
                    Continuar
                </label>
            </Row>
        </div>);
    }

    //-+-+-+-+-+-+-+-+-+ Login preinscrip
    loginPreinsc = (mail, password, spinner) => {
        if (mail === '' || password === '') {
            alertWarning('Es necesario llenar los campos de usuario y contraseña para realizar esta operación.');
        } else {
            fetch(AppEnv.apiGes + 'login/preinscripcion', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: mail,
                    password: password,
                    id_escuela: AppEnv.SchoolId
                })
            }).then(res => res.json())
                .then(responseJson => {
                    if (responseJson.error !== 'Unauthorized') {
                        if (responseJson.estatus !== 'alta') {
                            this.saveItem('idTutor', responseJson.toString());
                            this.saveItem('uri', this.state.uri);
                            this.saveItem('schoolId', AppEnv.SchoolId);
                            window.location.reload();
                        } else {
                            alertWarning('Ya has sido dado de alta, puedes continuar el proceso de los demás aspirantes en el apartado de inscripciones en el menú de la aplicación');
                        }
                    } else {

                        switch (responseJson.error.status_code) {
                            case 422:
                                alertFail('Es necesario poner un email válido.');
                                break;
                            case undefined:
                                alertFail('Usuario o contraseña Incorrectos. Ingresa los datos correctos');
                                break;
                            case 403:
                                alertFail('Usuario o contraseña incorrectos. Si el error persiste solicite ayuda.');
                                break;
                            case 500:
                                alertFail('Error interno. Por el momento no se puede procesar su solicitud, intente más tarde.');
                                break;
                            case 401:
                                alertFail('Credenciales incorrectas. Intente de nuevo por favor.');
                                break;
                            default:
                                alertFail('Solicite ayuda por favor');
                        }
                    }
                }).catch(error => {
                alertFail('Revisa tu conexión a internet. Si el problema persiste solicita ayuda.');
            });
        }
    };

    async saveItem(key, item) {
        // await sessionStorage.setItem(key, item.toString());
        if (item !== undefined && item !== null) {
            await sessionStorage.setItem(key, item.toString());
        } else {
            await sessionStorage.setItem(key, '');
        }
    }

    handleEmailPreinscrip(event) {
        this.setState({emailPreinscrip: event.target.value});
    }

    handlePasswordPreinscrip(event) {
        this.setState({passwordPreinscrip: event.target.value});
    }

    correoNip(event) {
        this.setState({emailNip: event.target.value});
    }

    async requestCorreo(c) {
        if (c === '') {
            alertWarning('Escriba un correo electronico valido para continuar');
        } else {
            await fetch(AppEnv.api + 'VZ6RL9VILW86CA/recuperar/nip/' + c,
                {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    return response;
                }).then(() => {
                    alertWarning('Se enviará un correo a la dirección email que proporcionaste con un nuevo NIP para continuar con el proceso de admisión')
                    this.setState({modalNip: false, emailNip: ''});
                });
        }
    }

    rndLoginPre() {
        return (
            <div className="uk-width-1-1 centerAll">
                <Modal center={true} open={this.state.modalNip}
                       onClose={() => [(this.state.modalNip = false), this.setState({aux: 0})]}>
                    <Col style={{
                        margin: 0,
                        padding: 15,
                        // height: '20vMax',
                        backgroundColor: AppEnv.fourthColor
                    }} className='modalWidth scroll centerAll'>
                        <Row style={{marginTop: 10}} className='uk-width-1-1 main_title'>
                            Ingrese el correo con el que se dio de alta
                        </Row>
                        <div>
                            <label className='labelform section_title_two'>
                                E-mail
                            </label>
                            <div>
                                <input style={{borderRadius: 6, textAlign: 'left'}}
                                       className='uk-input uk-width-1-1 work1'
                                       onChange={(event) => this.correoNip(event)}
                                       id='login-form-ce-username' type='email' placeholder='correo@ejemplo.com'/>
                            </div>
                        </div>
                        <Row className="uk-width-1-1 centerH" style={{marginTop: 15}}>
                            <Row style={{marginTop: 15}} className='centerAll'>
                                <a onClick={() => this.setState({modalNip: false})}>
                                    <div style={{
                                        padding: 0,
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        borderRadius: 10,
                                        border: '1px solid',
                                        borderColor: AppEnv.secondColor,
                                        backgroundColor: AppEnv.fourthColor
                                    }} className='uk-button uk-box-shadow-small'>
                                        <i className='fas fa-times-circle fa-1x'
                                           style={{color: AppEnv.secondColor, marginRight: 5}}/>
                                        <label className='normal_text'
                                               style={{color: AppEnv.secondColor}}>Cancelar</label>
                                    </div>
                                </a>
                            </Row>
                            &nbsp;
                            <Row style={{marginTop: 15}} className='centerAll'>
                                <a onClick={() => this.requestCorreo(this.state.emailNip)}>
                                    <div style={{
                                        padding: 0,
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        borderRadius: 10,
                                        border: '1px solid',
                                        borderColor: AppEnv.secondColor,
                                        backgroundColor: AppEnv.secondColor
                                    }} className='uk-button uk-box-shadow-small'>
                                        <i className="fas fa-plus-circle fa-1x"
                                           style={{color: AppEnv.fourthColor, marginRight: 5}}/>
                                        <label className='normal_text' style={{color: AppEnv.fourthColor}}>Restablecer
                                            NIP</label>
                                    </div>
                                </a>
                            </Row>
                        </Row>
                    </Col>
                </Modal>
                <div style={{marginTop: 25, color: AppEnv.secondColor, textAlign: 'center'}}
                     className='uk-width-1-1 centerAll subnegritas'>Continuar proceso
                </div>
                <label className="normal_text" style={{
                    margin: 0,
                    padding: 0,
                    marginTop: 10,
                    textAlign: 'left',
                    fontSize: '.8rem'
                }}>
                    Ingrese el correo con el que inició el registro seguido de la clave que se envió al mismo.
                </label>
                <form>
                    <div style={{marginTop: 10}}>
                        <label className='labelform section_title_two'>
                            E-mail
                        </label>
                        <div>
                            <input style={{borderRadius: 6, textAlign: 'left'}} className='uk-input uk-width-1-1 work1'
                                   onChange={(text) => this.handleEmailPreinscrip(text)} id='login-form-ce-username'
                                   type='email' placeholder='correo@ejemplo.com'/>
                        </div>
                    </div>
                    <div>
                        <label className='labelform section_title_two'>
                            PIN de acceso
                        </label>
                        <div>
                            <input style={{borderRadius: 6, textAlign: 'left'}} className='uk-input uk-width-1-1 work1'
                                   onChange={(text) => this.handlePasswordPreinscrip(text)} id='login-form-ce-password'
                                   type='password' placeholder='***********'/>
                        </div>
                    </div>
                </form>
                <Row className="uk-width-1-1 centerAll">
                    <button style={{
                        marginTop: 25,
                        borderRadius: 9,
                        backgroundColor: AppEnv.secondColor,
                        textAlign: 'center',
                        padding: 0
                    }}
                        // type='submit'
                            onClick={() => this.loginPreinsc(this.state.emailPreinscrip, this.state.passwordPreinscrip)}
                            className='uk-button uk-button-medium uk-width-1-3 botontxt'>
                        Continuar
                    </button>
                </Row>
                <Row style={{marginTop: 20}} className="uk-width-1-1 centerAll ">
                    <div className='uk-width-1-2 centerAll section_title_two' style={{textAlign: 'center'}}>
                        <a className='uk-link-heading' onClick={() => this.setState({modalNip: true})}>
                            <small>Olvidé mi PIN</small>
                        </a>
                    </div>
                </Row>
            </div>
        );
    }


    rndAdmision() {
        if (this.state.preinscrip === true) {
            return <div style={{
                backgroundColor: AppEnv.fourthColor,
                margin: 0,
                padding: 0,
                height: '100vh',
            }} className='centerAll uk-width-5-6 uk-width-2-3@s uk-width-5-6@m uk-width-2-3@l centerAll'>
                <Preinscrip dataSchool={this.state.dataSchool} globals={this.state.otherGlobals}/>
            </div>;
        }
        return (
            <Row style={{
                backgroundColor: AppEnv.fourthColor,
                height: '100vh',
                margin: 0,
                padding: 0
            }} className='centerAll uk-width-5-6 uk-width-2-3@s uk-width-5-6@m uk-width-2-3@l centerAll'>
                <div className="uk-width-1-1 centerAll">
                    <a className='uk-link-heading' onClick={() => {
                        if (this.state.selectLevels === true) {
                            this.setState({selectLevels: false, selectSchool: -1});
                        } else {
                            this.setState({admision: false});
                        }
                        if (this.state.loginInputs === true) {
                            this.setState({loginInputs: false});
                        }
                    }}>
                        <Row style={{
                            padding: 0,
                            margin: 0,
                            justifyContent: 'flex-start',
                            alignItems: 'center'
                        }} className='uk-width-1-1'>
                            <i className="fas fa-arrow-circle-left fa-1x" style={{color: 'black'}}/>
                            <label className='normal_text'
                                   style={{marginLeft: 10, textAlign: 'left', lineHeight: 1.25}}>
                                Atrás
                            </label>
                        </Row>
                    </a>
                    <Row style={{marginBottom: 5, padding: 5, marginTop: 25}} className='centerAll'>
                        <img className='lazyload imagenl'
                             data-src={getLogo()}
                             alt=''/>
                    </Row>
                    {this.state.selectLevels === false && this.state.loginInputs === false ? this.rndTwoBtns() : null}
                    {this.state.selectLevels === true && this.state.loginInputs === false && AppEnv.tipoApp !== '1' && this.state.searchSchool === false ? this.rndSelectEsc() : null}
                    {this.state.selectLevels === true && this.state.loginInputs === false && AppEnv.tipoApp === '1' ?
                        <div className="uk-width-1-1">
                            <div style={{marginTop: 25, color: AppEnv.secondColor, textAlign: 'center'}}
                                 className='uk-width-1-1 centerAll subnegritas'>¡Quiero ser parte!
                            </div>
                            <div className="uk-width-1-1 normal_text txtnegritas" style={{
                                margin: 0,
                                padding: 0,
                                marginTop: 10,
                                lineHeight: 1,
                                textAlign: 'left',
                                fontWeight: '600'
                            }}>
                                En nuestra institución contamos con todos los niveles de educación básica.
                                Seleccione el nivel con el que desea iniciar el proceso de admisión:
                            </div>
                            {this.rndLevels()}
                            <Row style={{marginTop: 15}} className='uk-width-1-1 centerAll'>
                                <a onClick={() => this.seguirProceso()} data-uk-tooltip='Continuar'>
                                    <button style={{
                                        padding: 0,
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        borderRadius: 10,
                                        backgroundColor: this.state.selected !== -1 ? AppEnv.secondColor : AppEnv.grayColorFive
                                    }} className='uk-button uk-box-shadow-small'>
                                        <label className='normal_text'
                                               style={{color: AppEnv.fourthColor}}>Continuar</label>
                                        <i className='fas fa-arrow-right fa-1x'
                                           style={{color: AppEnv.fourthColor, marginLeft: 5}}/>
                                    </button>
                                </a>
                            </Row></div> :
                        null}
                    {this.state.loginInputs === true ? this.rndLoginPre() : null}
                </div>
            </Row>
        );
    }

    async logOutPreinscrip() {
        confirmAlert({
            customUI: ({onClose}) => {
                return customAlert('Cerrar sesión',
                    'Está a punto de cerrar la sesión de inscripción ¿seguro que desea salir?', 2,
                    'Sí', 'No', null,
                    () => [sessionStorage.removeItem('idTutor'), window.location.reload(), onClose()], () => [onClose()]);
            }
        });
    }

    async getInscription(escuela) {
        await this.setState({
            dataSchool: escuela.data_cliente,
            otherGlobals: escuela.globals,
            preinscrip: true,
            searchSchool: false
        });
    }

    renderLogin() {
        return <Row style={{backgroundColor: AppEnv.fourthColor}}
                    className="uk-width-1-1 centerAll">
            {this.state.loadingLogin
                ? suspenseFallback()
                : <Row className="uk-width-1-1 centerAll">
                    {this.state.hasIdTutor === false && this.state.admision === false
                        ? this.state.mobile
                            ? this.rndLoginMobile()
                            : this.rndLogin()
                        : null}
                    {this.state.admision === true && this.state.searchSchool === false ? this.rndAdmision() : null}
                    {this.state.hasIdTutor === true ? <Row
                        style={{
                            backgroundColor: AppEnv.fourthColor,
                            height: '100vh',
                            margin: 0,
                            padding: 0
                        }} className='centerAll uk-width-5-6 uk-width-2-3@s uk-width-5-6@m uk-width-2-3@l'>
                        <div className="uk-width-1-1">
                            <a className='uk-link-heading' onClick={() => this.logOutPreinscrip()}>
                                <Row style={{
                                    padding: 0,
                                    margin: 0,
                                    justifyContent: 'flex-start',
                                    alignItems: 'center'
                                }} className='uk-width-1-1'>
                                    <i className="fas fa-arrow-circle-left fa-1x" style={{color: 'black'}}/>
                                    <label className='normal_text'
                                           style={{marginLeft: 10, textAlign: 'left', lineHeight: 1.25}}>
                                        Atrás
                                    </label>
                                </Row>
                            </a>
                            <AspirantesTutor history={this.props.history}/>
                        </div>
                    </Row> : null}
                    {this.state.searchSchool === true ?
                        <Row style={{
                            backgroundColor: AppEnv.fourthColor,
                            height: '100vh',
                            // width: '60%',
                            margin: 0,
                            padding: 0
                            // paddingLeft: 50,
                            // paddingRight: 50,
                            // borderRadius: 15
                        }} className=' uk-width-5-6 uk-width-2-3@s uk-width-5-6@m uk-width-2-3@l centerH'>
                            <div className="uk-width-1-1" style={{marginTop: 50}}>
                                <a className='uk-link-heading'
                                   onClick={() => this.setState({
                                       searchSchool: false,
                                       elTipo: '',
                                       elNivel: ''
                                   })}>
                                    <Row style={{
                                        padding: 0,
                                        margin: 0,
                                        justifyContent: 'flex-start',
                                        alignItems: 'center'
                                    }} className='uk-width-1-1'>
                                        <i className="fas fa-arrow-circle-left fa-1x"
                                           style={{color: 'black'}}/>
                                        <label className='normal_text'
                                               style={{
                                                   marginLeft: 10,
                                                   textAlign: 'left',
                                                   lineHeight: 1.25
                                               }}>
                                            Atrás
                                        </label>
                                    </Row>
                                </a>
                                <SelectEscuela
                                    elNivel={this.state.elNivel}
                                    id_country={this.props.country.id}
                                    getInscription={(escuela) => this.getInscription(escuela)}/>
                            </div>
                        </Row> : null}
                </Row>}
        </Row>
    }

    render() {
        return (
            <Grid style={{
                margin: 0,
                padding: 0,
                backgroundColor: AppEnv.fourthColor
            }}>
                {this.state.loading ? <Loading/> : null}
                <Row style={{height: '100vh'}} className="uk-width-1-1 centerAll">
                    <Col xl={7} lg={7} md={7} hiddenDown={'sm'} style={{
                        margin: 0,
                        padding: 0,
                        height: '100vh',
                        borderRadius: 0
                    }} className='centerAll'>
                        <img style={{
                            objectFit: 'cover',
                            height: '100vh',
                        }} className='lazyload centerAll uk-width-1-1' data-src={this.state.fondo} alt="Fondo"/>
                    </Col>
                    <Col xl={5} lg={5} md={5} sm={12} style={{
                        margin: 0,
                        padding: 0
                    }} className='centerAll'>
                        {this.renderLogin()}
                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        countries: state.gestion.countries,
        country: state.gestion.country
    };
};

export default connect(mapStateToProps, {fetchCountries, setCountry, setInitValues})(Login);
